var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.839,
    height: 22.833,
    viewBox: "0 0 22.839 22.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "upload",
    d: "M9.663,8.52l2.615-2.626V16.845a1.142,1.142,0,1,0,2.284,0V5.893L17.177,8.52A1.147,1.147,0,1,0,18.8,6.9L14.23,2.33a1.181,1.181,0,0,0-1.622,0L8.041,6.9A1.147,1.147,0,0,0,9.663,8.52ZM23.7,15.7a1.142,1.142,0,0,0-1.142,1.142v4.568a1.142,1.142,0,0,1-1.142,1.142H5.426a1.142,1.142,0,0,1-1.142-1.142V16.845a1.142,1.142,0,1,0-2.284,0v4.568a3.426,3.426,0,0,0,3.426,3.426H21.413a3.426,3.426,0,0,0,3.426-3.426V16.845A1.142,1.142,0,0,0,23.7,15.7Z",
    transform: "translate(-2 -2.005)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dd4aeb1d9dae6d990429d404231a1549.svg";
export { ForwardRef as ReactComponent };